import React from "react";

export default function CompanyName() {
  return <div className="text-3xl font-extrabold font-avenir">resourceManagement</div>;
}
